import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest, HttpEventType, HttpResponse } from '@angular/common/http';
import { RequestOptions } from '@angular/http';
import { environment } from '../../environments/environment';


@Injectable()
export class FreeService {
  public progress: number;

  constructor(private http: HttpClient) { }

  myFreeItem(data) {
    return this.http.post<any>(environment.apiUrl + 'free/myfreeitems', data).map(data => {
      if (data) {
        return data;
      } else {
        return data;
      }
    });
  }

  addNewTrade(adData) {
    // Seller Detail
    var userInfo = JSON.parse(localStorage.getItem('currentUser'));
    adData.seller_id = userInfo.result.id;
    adData.videos ? adData.videos : null;
    adData.images ? adData.images : null;
    adData.music ? adData.music : null;
    return this.http.post<any>(environment.apiUrl + 'free/newitem', adData).map(data => {
      if (data.status === 200) {
        return data.result;
      } else {
        return [];
      }
    });
  }

  updateTrade(adData) {
    return this.http.post<any>(environment.apiUrl + 'free/updateitem', adData).map(data => {
      if (data) {
        return data;
      } else {
        return data;
      }
    });
  }

  sentTrade(data) {
    return this.http.post<any>(environment.apiUrl + 'free/sendrequests', data).map(data => {
      if (data) {
        return data;
      } else {
        return [];
      }
    });
  }

  searchFreeProduct(data) {
    return this.http.post<any>(environment.apiUrl + 'free/searchitems', data).map(data => {
      if (data) {
        return data;
      } else {
        return [];
      }
    });
  }

  bookFreeProduct(data) {
    return this.http.post<any>(environment.apiUrl + 'free/booking', data).map(data => {
      if (data) {
        return data;
      } else {
        return [];
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/_services/free.service.ts